<div fxLayout="row" fxLayoutAlign="center center">
  <mat-spinner mode="indeterminate"></mat-spinner>
</div>